module.exports = __webpack_public_path__ + "static/media/compact-track-loaders.da1eba26.jpg";